import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import User from './User';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import { NAV } from '../../config-global';


// ----------------------------------------------------------------------

export default function UserLayout() {

    const [open, setOpen] = useState(true);

    const [navWidth, setNavWidth] = useState(NAV.W_DASHBOARD);

    const handleOpen = () => {
        setOpen(true);
        setNavWidth(NAV.W_DASHBOARD);
    };


    const handleClose = () => {
        setOpen(false);
        setNavWidth(0);
    };

        return (
            <>
                <Header openNav={open} onOpenNav={handleOpen} navWidth={navWidth} />

                <Box
                    sx={{
                        display: { lg: 'flex' },
                        minHeight: { lg: 1 },
                    }}
                >
                    {/*  {renderNavVertical}  */}
                    <NavVertical openNav={open} onCloseNav={handleClose} onOpenNav={handleOpen} navWidth={navWidth} />

                    <User>
                      
                        <Outlet />
                    </User>
                </Box>

            </>
        );
    

}
